import {useDispatch, useSelector} from "react-redux";
import {closeMobilePopup} from "../../redux/actions";
import React from "react";
import {Qaa} from "../../pages/Qaa";

export const MobilePopup = () => {
    const dispatch = useDispatch()
    const lang = useSelector(state => state.app.currentLang)
    const mobilePopup = useSelector(state => state.app.mobilePopup)

    if (!mobilePopup) {
        return null;
    }
    return (
        <div className="mobilePopup">
            <div className="mobilePopup__back" onClick={() => dispatch(closeMobilePopup())}></div>
            <div className="mobilePopup__wrap">
                <div className="mobilePopup__box">
                    <div className="mobilePopup__head">
                        {
                            lang.menu3
                        }
                        <div className="mobilePopup__close" onClick={() => dispatch(closeMobilePopup())}>

                        </div>
                    </div>
                    <div className="mobilePopup__body">
                        {
                            lang.qaa.length > 0 && (<Qaa/>)
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}